export const IndividualOrderableEnum = {
    MEAL_KIT: 'meal_kit',
    PERSONAL_MENU: 'personal_menu',
};
